import { Component, EventEmitter, forwardRef, input, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractIdbaService } from '../../utils/abstract-idba-service.service';

interface AutocompleteOptions {
  label: string,
  codigo: number
};

@Component({
  selector: 'app-generic-autocomplete',
  templateUrl: './generic-autocomplete.component.html',
  styleUrls: ['./generic-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => GenericAutocompleteComponent),
    }
  ]
})

export class GenericAutocompleteComponent implements OnInit, ControlValueAccessor {
  @Input() public service: AbstractIdbaService;
  @Input() public fieldLabel: string;
  @Input() public formGroup;
  @Input() public formControlName: string;
  @Input() public autoLoad: boolean;
  @Input() public placeholder: string;
  @Input() public isCampoGenerico: boolean;
  @Input() public modulo: string;
  @Input() public assunto: string;
  @Input() public onSelectOptionAction: any;
  @Input() public originalClass: any;
  @Input() public readonly: boolean = false;
  @Input() public id: string;
  @Input() public element: any = null;
  @Input() public value: any = null;
  @Input() public setDefaultFirst: boolean = false;
  @Input() public setFirstIfOnly: boolean = false;
  @Input() public idSelected: number | null = null;
  @Input() public displayWithProperty: string = "";
  @Input() public showDisplayWithProperty: boolean = false;

  @Output() selectOption: EventEmitter<any> = new EventEmitter();
  constructor() { }

  get displayWith() {
    return (value: any) => {

      if (!value) return '';

      if (this.showDisplayWithProperty) {
        return value[this.displayWithProperty];
      }

      return value && value['displayWith'] ? value['displayWith'] : "";
    };
  }

  ngOnInit(): void {
    if (!this.service.modelField[this.formControlName]) {
      this.service.modelField[this.formControlName] = this.service.model.convertToModel("");
    }
    if (this.autoLoad) {
      if (this.isCampoGenerico) {
        this.service.listAll(undefined, this.formGroup, this.formControlName, [this.modulo, this.assunto], undefined, undefined, undefined, this.setDefaultFirst, this.setFirstIfOnly, { idSelected: this.idSelected });
      } else {
        this.service.listAll(undefined, this.formGroup, this.formControlName, undefined, undefined, undefined, undefined, this.setDefaultFirst, this.setFirstIfOnly, { idSelected: this.idSelected });
      }

    }
  }

  onSelectOption(event) {
    if (event.option.value) {
      this.service.modelField[this.formControlName] = this.service.model.convertToModel(event.option.value);
    }

    const selected = event.option.value;
    this.selectOption.emit({ selectedOption: selected, fieldType: this.formControlName });
    this.formGroup.controls[this.formControlName].setValue(this.service.modelField[this.formControlName]);

    if (this.onSelectOptionAction) {
      this.onSelectOptionAction(event, this.formGroup, this.originalClass, this.element);
    }
  }

  writeValue(obj: any) { }
  registerOnChange(fn: any) { }
  registerOnTouched(fn: any) { }
  setDisabledState(isDisabled: boolean) { }
}
